import { Box } from '@chakra-ui/react';
import {
  AutoSuggest,
  AutoSuggestProps,
  FieldHelpText,
  InputVariant,
} from '@pluxee-design-system/core';
import { SkippableBaseControlProps } from '@pluxee-design-system/react-hook-form';
import { getVariant } from 'common/forms/utils';
import { useController } from 'react-hook-form';

interface AutoSuggestControlProps
  extends Omit<
      AutoSuggestProps,
      'initialValue' | 'isDisabled' | 'isReadOnly' | 'name' | 'onInputChange' | 'value'
    >,
    SkippableBaseControlProps {}

const AutoSuggestControl = ({
  control,
  disabled,
  id,
  isDisabled,
  isReadOnly,
  name,
  readonly,
  rules,
  skipSuccess = false,
  skipVariant = false,
  ...autoSuggestProps
}: AutoSuggestControlProps) => {
  const { field, fieldState, formState } = useController({
    name,
    control,
    rules,
  });
  const { error } = fieldState;
  const variant = getVariant(
    formState,
    fieldState,
    isReadOnly ?? readonly,
    skipSuccess,
    skipVariant,
  );

  return (
    <Box
      sx={{
        'ul > li': {
          height: 'initial !important',
        },
      }}
    >
      <AutoSuggest
        name={name}
        id={id}
        initialValue={field.value}
        onInputChange={field.onChange}
        variant={variant === InputVariant.SUCCESS ? undefined : variant}
        disabled={variant !== InputVariant.READONLY && (disabled ?? isDisabled)}
        onBlur={field.onBlur}
        {...autoSuggestProps}
      />
      {error?.message && <FieldHelpText text={error.message} variant={InputVariant.ERROR} />}
    </Box>
  );
};

export default AutoSuggestControl;
